export default __webpack_public_path__ + "static/media/ada-engyj.499c28db.png";